import { render } from "./ShareholderVote.vue?vue&type=template&id=5147fca2&scoped=true"
import script from "./ShareholderVote.vue?vue&type=script&lang=js"
export * from "./ShareholderVote.vue?vue&type=script&lang=js"

import "./ShareholderVote.vue?vue&type=style&index=0&id=5147fca2&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5147fca2"]])

export default __exports__